/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum ImageSize {
  Default = 'Default',
  Small = 'Small',
  Medium = 'Medium',
  Stretched = 'Stretched',
  Contained = 'Contained',
}
